import { LayoutComponent } from "@jelly/lesson";
import variables from "../../../../../../../assets/styles/sass-resources.scss";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 2,
        colsSize: [1, 2],
        rowsSize: [0, 0],
        rowSpan: {
          "0:1": 2,
        },
        gap: "10px",
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/case01/slide03-create-image01.svg`,
                    styles: {
                      height: "266px",
                    },
                  },
                },
              },
            },
            {
              variant: "layout",
              data: {
                type: "table",
                options: {
                  cols: 2,
                  rows: 5,
                  colSpan: {
                    "4:0": 2,
                  },
                  rowsSize: [1, 0, 1, 0, 0],
                  components: [
                    [
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "image",
                            options: {
                              src: `${config.ASSETS_URL}/02/case01/slide03-create-image02.svg`,
                            },
                          },
                        },
                      },
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "image",
                            options: {
                              src: `${config.ASSETS_URL}/02/case01/slide03-create-image03.svg`,
                            },
                          },
                        },
                      },
                    ],
                    [
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "audioButton",
                            options: {
                              url: `${config.ASSETS_URL}/02/case01/slide03-create-decreased-sharpness.wav`,
                              text: "Decreased Sharpness during Grinding",
                              icon: "cis-volume-high",
                              theme: "secondary",
                              shape: "round",
                              size: "small",
                            },
                          },
                        },
                      },
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "audioButton",
                            options: {
                              url: `${config.ASSETS_URL}/02/case01/slide03-create-increased-sharpness.wav`,
                              text: "Increased Sharpness during Grinding",
                              icon: "cis-volume-high",
                              theme: "secondary",
                              shape: "round",
                              size: "small",
                            },
                          },
                        },
                      },
                    ],
                    [
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "image",
                            options: {
                              src: `${config.ASSETS_URL}/02/case01/slide03-create-image04.svg`,
                            },
                          },
                        },
                      },
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "image",
                            options: {
                              src: `${config.ASSETS_URL}/02/case01/slide03-create-image05.svg`,
                            },
                          },
                        },
                      },
                    ],
                    [
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "audioButton",
                            options: {
                              url: `${config.ASSETS_URL}/02/case01/slide03-create-decreased-tonality.wav`,
                              text: "Decreased Tonality during warm-up",
                              icon: "cis-volume-high",
                              theme: "secondary",
                              shape: "round",
                              size: "small",
                            },
                          },
                        },
                      },
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "audioButton",
                            options: {
                              url: `${config.ASSETS_URL}/02/case01/slide03-create-increased-tonality.wav`,
                              text: "Increased Tonality during warm-up",
                              icon: "cis-volume-high",
                              theme: "secondary",
                              shape: "round",
                              size: "small",
                            },
                          },
                        },
                      },
                    ],
                    [
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "image",
                            options: {
                              src: `${config.ASSETS_URL}/02/case01/slide03-create-image06.svg`,
                            },
                          },
                          styles: {
                            height: "34px",
                          },
                        },
                      },
                    ],
                  ],
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    scrollbars: false,
                    data:
                      "Once troublesome sound components (e.g. specific frequency regions) have been identified, potential modifications or variants can be tested by changing the characteristics of the sound, for example through filtering or by adding components to mask unpleasant sound sources. Amplifying or decreasing these problematic components can increase the range of available sounds and ease the process of generating sound quality metrics. Depending on the task and available information the generated variants can be based on the specific exchange, addition or adjustment of physical components such as mounts, pumps, dampening material, etc.",
                    styles: {
                      fontSize: "12px",
                      fontWeight: 600,
                    },
                  },
                },
                styles: {
                  width: "93%",
                  alignItems: "flex-start",
                },
              },
            },
          ],
        ],
      },
      styles: {
        borderBottom: `solid 1px ${variables["default-light"]}`,
      },
    },
  },
];

export default components;
